import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {User} from '../_models/user.model';
import {KeycloakService} from 'keycloak-angular';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private keycloakService: KeycloakService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public set currentUserValue(user: User) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
  }

  login(AccessToken: string) {
    const userTemp: User = JSON.parse(localStorage.getItem('currentUser'));
    const user = new User();

    if (userTemp) {
      user.azure_id = userTemp.azure_id;
      user.resource_access = userTemp.resource_access;
      user.ProfilePhoto = userTemp.ProfilePhoto;
      user.access_token_azure = userTemp.access_token_azure;
      user.email = userTemp.email;
      user.family_name = userTemp.family_name;
      user.name = userTemp.name;
      user.lang = userTemp.lang;
      user.given_name = userTemp.given_name;
      console.log("User Temp = " + userTemp.lang)
    }

    return this.keycloakService.loadUserProfile().then((userProfile) => {
      user.fromJsonKeyCloak(userProfile);
      this.currentUserSubject.next(user);
    }).catch(error => {
      console.error(error);
    });
  }

  logout() {
    // this.oAuthService.logOut();
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    // location.reload(true);
  }
}
